module.exports = __webpack_public_path__ + "media/images/textSelectionSample__dropdown@2x-8aa9711468a30248c09f5a592ce529d1.png";